import { useEffect, useState } from "react";
import { Bell, BellOff, BellRing } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";

const b64ToU8 = (v) => { const p = "=".repeat((4 - (v.length % 4)) % 4); const s = (v + p).replace(/-/g, "+").replace(/_/g, "/"); return Uint8Array.from(atob(s), (c) => c.charCodeAt(0)); };
const supported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window && window.isSecureContext;

export function PushNotifCard() {
  const [state, setState] = useState("loading"); // loading | off | on | unsupported | denied
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!supported()) return setState("unsupported");
    if (Notification.permission === "denied") return setState("denied");
    navigator.serviceWorker.ready.then((r) => r.pushManager.getSubscription()).then((s) => setState(s ? "on" : "off")).catch(() => setState("off"));
  }, []);
  const enable = async () => {
    setBusy(true);
    try {
      const perm = Notification.permission === "granted" ? "granted" : await Notification.requestPermission();
      if (perm !== "granted") { setState(perm === "denied" ? "denied" : "off"); return toast.error("Izin notifikasi tidak diberikan"); }
      const reg = await navigator.serviceWorker.ready;
      let sub = await reg.pushManager.getSubscription();
      if (!sub) { const { data } = await api.get("/push/public-key"); sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(data.key) }); }
      await api.put("/push/subscriptions", sub.toJSON());
      setState("on"); toast.success("Notifikasi aktif di perangkat ini");
      api.post("/push/test").catch(() => {});
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const disable = async () => {
    setBusy(true);
    try { const reg = await navigator.serviceWorker.ready; const sub = await reg.pushManager.getSubscription(); if (sub) { await api.delete("/push/subscriptions", { data: { endpoint: sub.endpoint } }); await sub.unsubscribe(); } setState("off"); toast.success("Notifikasi dimatikan"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (state === "loading") return null;
  return (
    <div className="rounded-2xl border border-border bg-card p-3 flex items-center gap-3" data-testid="push-notif-card">
      <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${state === "on" ? "bg-emerald-500/15 text-emerald-500" : "bg-amber-500/15 text-amber-500"}`}>{state === "on" ? <BellRing className="w-5 h-5" /> : <Bell className="w-5 h-5" />}</div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold">Notifikasi HP</div>
        <div className="text-[11px] text-muted-foreground" data-testid="push-notif-status">
          {state === "on" && "Aktif — chat baru, tugas, dan pengingat absen masuk ke HP ini walau aplikasi tertutup."}
          {state === "off" && "Dapatkan notifikasi chat baru, tugas, dan pengingat absen walau aplikasi tertutup."}
          {state === "denied" && "Izin notifikasi diblokir di browser. Buka pengaturan situs → Notifikasi → Izinkan."}
          {state === "unsupported" && "Browser ini belum mendukung. Di iPhone: pasang aplikasi ke layar utama dulu, lalu buka dari sana."}
        </div>
      </div>
      {state === "on" ? <Button size="sm" variant="outline" className="h-8" disabled={busy} onClick={disable} data-testid="push-notif-off"><BellOff className="w-4 h-4 mr-1" /> Matikan</Button>
        : state === "off" ? <Button size="sm" className="h-8 bg-emerald-600 hover:bg-emerald-500 text-white" disabled={busy} onClick={enable} data-testid="push-notif-on"><Bell className="w-4 h-4 mr-1" /> {busy ? "..." : "Aktifkan"}</Button> : null}
    </div>
  );
}
